import querystring from 'query-string';
import FeatureFlags from './featureFlags';

export default () =>
  FeatureFlags.get('personalization') ||
  querystring.parse(window.location.search).enablepz === 'true';
